<div class="detail-content__products container-fluid" *ngIf="products.length > 0">
    <ng-container *ngIf="type === 'EXHIBITOR'">
      <h3 class="bold">{{ 'CARD_DETAIL.PRODUCTS' | translate }} </h3>
    </ng-container>
    <ng-container *ngIf="type === 'PRODUCT'">
      <h3 class="bold">{{ 'CARD_DETAIL.LONG_PRODUCTS' | translate }} {{title}}</h3>
    </ng-container>
    <div class="row h-100">
      <ng-container *ngFor="let item of products; index as i">
        <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6" (click)="goDetails(item)">
          <div [ngClass]="'card card-custom'">
            <div class="ex ex--grid pointer">
              <div class="ex__img-container img-custom">
                <img class="ex-img" [src]="setImage(item.mainImageUrl)">
              </div>
              <div class="ex__data-border"></div>
              <div class="ex__data-container">
                <div class="ex__data">
                  <a class="ex__data-title long-text-two-line" [title]="_api(item.translations, 'name')">
                    {{_api(item.translations, 'name')}}
                  </a>
                </div>
                <div class="ex__stand">
                  <span class="product__exhibitor-name long-text-four-line">
                    {{_api(item.translations, 'description')}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
</div>
